export default {
  total: {
    vouchersPrice: '商品：',
    deliveryPrice: '配送料：',
    totalPrice: 'ご請求金額：',
    createQuotation: '見積書の発行'
  },
  order: {
    order: '注文',
    notice1: '＊複数の封筒にギフト券を分けて封入したい場合は『この注文内容をコピー』',
    notice2: 'もしくは『注文を新規追加』を押してご入力ください。',
    orderCount: '注文枚数',
    validityPeriod: '有効期間',
    wrappingInfo: '熨斗紙・掛け紙',
    messageCard: 'メッセージカード',
    receiver: 'お届け先',
    from: '差出人',
    messageCardDialogTitle: 'メッセージカードを入力',
    receiverDialogTitle: 'お届け先を入力',
    shipperDialogTitle: '差出人を入力',
    wrappingTypeDialogTitle: '熨斗紙・掛け紙を選択',
    inscriptionDialogTitle: '表書き・名入れを入力',
    name: 'お名前：',
    kana: 'フリガナ：',
    postcode: '郵便番号：',
    postcodeInput: '住所自動入力',
    prefecture: '都道府県：',
    city: '市区町村・番地：',
    buildings: '建物名・部屋番号：',
    company: 'ご法人名：',
    tel: '電話番号：',
    email: 'メールアドレス：',
    nameNotes: '※ 漢字仮名、英字で入力してください。',
    kanaNotes: '※ カタカナ、英字で入力してください。',
    cityNotes: '※ 番地抜けにご注意ください。',
    buildingsNotes: '※ 住所にマンション・アパート名などがある場合。',
    companyNotes: `※ 勤務先の場合は「会社名・部署名」などを入力してください。`,
    namePlaceholder: '星野太郎',
    kanaPlaceholder: 'ホシノタロウ',
    postcodePlaceholder: '3890111',
    cityPlaceholder: '北佐久郡軽井沢町長倉2148',
    buildingsPlaceholder: '星野マンション',
    companyPlaceholder: '株式会社星野リゾート',
    telPlaceholder: '08012345678',
    emailPlaceholder: 'taro@hoshinoresorts.com',
    wrappingTypeSelect: '以下からお選びください。',
    wrappingType1Name: 'なし',
    wrappingType2Name: '紅白10本結び切り',
    wrappingType3Name: '紅白5本結び切り',
    wrappingType4Name: '紅白蝶結び',
    wrappingType2Description: 'ご結婚祝、寿、ご結婚内祝い',
    wrappingType3Description: '快気祝',
    wrappingType4Description:
      '結婚記念日、お中元、お歳暮、出産祝、長寿祝、御礼、粗品',
    wrappingTypeNext: '表書き・名入れへ',
    kotobuki: '寿',
    iwai: '祝',
    freeWord: 'フリーワード',
    freeWord1: 'フリーワード1行',
    freeWord2: 'フリーワード2行',
    freeWordNotes: '※ 最大10文字まで入力可能',
    inscriptionFreeWordLabel: '表書き：',
    inscriptionFreeWordLabel1: '表書き右：',
    inscriptionFreeWordLabel2: '表書き左：',
    shipperNameFreeWordLabel: '名入れ：',
    shipperNameFreeWordLabel1: '名入れ右：',
    shipperNameFreeWordLabel2: '名入れ左：',
    inscriptionLabel: '表書き：',
    shipperNameLabel: '名入れ：',
    inscriptionBack: '戻る',
    wrappingInfoTooltipLabel: '表示内容：',
    referredOrderSelectLabel: 'と同じ',
    alertDeleteOrderTitle: 'を削除しますか?',
    alertDeleteOrder: '注文内容が破棄されます。よろしいですか?',
    alertReleaseReferrings:
      '\nこの注文を参照しているお届け先と差出人はリセットされます。',
    alertCloseModalTitle: '入力内容を保存せずに閉じる',
    alertCloseModal: '入力内容は保存されません。よろしいですか?',
    alertCancelEditTitle: '編集内容は反映されません',
    alertCancelEdit: '編集内容は反映されません。よろしいですか?',
    alertCheckCopyTitle: '入力内容が変わります',
    alertCheckCopy:
      'チェックをつけると、入力済みのお届け先と差出人を上書きします。よろしいですか?',
    alertUncheckCopyTitle: '配送料が変わります',
    alertUncheckCopy:
      'チェックをはずすと、同じ配送先でも料金が変更されます。よろしいですか?',
    referringTable: {
      name: 'お名前',
      kana: 'フリガナ',
      address: '住所',
      company: 'ご法人名',
      tel: '電話番号'
    },
    customerEditDialogTitle: 'ご注文者情報を編集',
    select: '選択する',
    copyReceiverValueLabel: 'のお届け先',
    copyShipperValueLabel: 'の差出人',
    copyShipperLabel: 'をコピー',
    paymentEditDialogTitle: 'お支払い情報を編集',
    deliveryEditDialogTitle: '配送情報を編集',
    messageCardTypeNone: 'なし',
    messageCardTypeInput: 'フリーワード',
    messageCardTypeWhitePaper: '白紙メッセージカード(手書き用)'
  },
  publish: {
    name: '宛名：',
    namePlaceholder: '星野太郎',
    nameNotes: '※ 漢字仮名、英字で入力してください。',
    quotationDialogTitle: '見積書発行',
    receiptDialogTitle: '領収書発行',
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/orderAggregators/common.js